/** Tells the page's step counter that something the server agreed to has happened. Names in site-stats src/sites.js. */
export type Step = "signin_sent" | "drawn" | "checkout";
// Also runs under the Node tests of requestDraw, where there is no page to tell.
export const counted = (step: Step) => { if (typeof document !== "undefined") document.dispatchEvent(new CustomEvent("stats", { detail: step })); };
